import PropTypes from "prop-types";
import React from "react";
import styled, { css, keyframes } from "styled-components";

import { BTTO_WALLET_GLASS } from "./bettoWalletTheme";

const shimmer = keyframes`
	0% {
		background-position: 120% 0;
	}
	100% {
		background-position: -120% 0;
	}
`;

const Root = styled.div`
	position: relative;
	width: 100%;
	min-width: 0;
`;

const Content = styled.div`
	width: 100%;
	min-width: 0;

	${({ $loading }) =>
		$loading &&
		css`
			visibility: hidden;
			pointer-events: none;
		`}
`;

const GlassLoadingCard = styled.div`
	position: absolute;
	inset: 0;
	z-index: 20;
	min-height: 220px;
	border-radius: 12px;
	overflow: hidden;
	isolation: isolate;
	pointer-events: all;
	background: ${BTTO_WALLET_GLASS.cardBg};
	border: 1px solid ${BTTO_WALLET_GLASS.border};
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
	backdrop-filter: blur(${BTTO_WALLET_GLASS.blur}) saturate(140%);
	-webkit-backdrop-filter: blur(${BTTO_WALLET_GLASS.blur}) saturate(140%);

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: radial-gradient(
				ellipse 90% 70% at 0% 0%,
				rgba(82, 151, 255, 0.22) 0%,
				transparent 58%
			),
			radial-gradient(
				ellipse 85% 65% at 100% 0%,
				rgba(82, 151, 255, 0.16) 0%,
				transparent 55%
			),
			linear-gradient(180deg, rgba(31, 37, 54, 0.72) 0%, rgba(18, 21, 31, 0.92) 100%);
		pointer-events: none;
		z-index: 0;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: linear-gradient(
			110deg,
			transparent 30%,
			rgba(255, 255, 255, 0.08) 50%,
			transparent 70%
		);
		background-size: 220% 100%;
		animation: ${shimmer} 1.8s ease-in-out infinite;
		pointer-events: none;
		z-index: 1;
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			animation: none;
			opacity: 0.35;
		}
	}
`;

export const BettoWalletGlassLoading = ({ loading, children }) => (
	<Root>
		<Content $loading={loading}>{children}</Content>
		{loading ? (
			<GlassLoadingCard
				role="status"
				aria-live="polite"
				aria-busy="true"
				aria-label="Loading"
				data-testid="betto-wallet-glass-loading"
			/>
		) : null}
	</Root>
);

BettoWalletGlassLoading.propTypes = {
	loading: PropTypes.bool,
	children: PropTypes.node,
};

BettoWalletGlassLoading.defaultProps = {
	loading: false,
};
